export const HAGGLE_ACCEPTABLE_MARGIN_REQUIRED = 'Max. Discount is required';
export const HAGGLE_START_DATETIME_REQUIRED = 'Start Date & Time is required';
export const HAGGLE_END_DATETIME_REQUIRED = 'End Date & Time is required';
export const HAGGLE_END_DATETIME_AFTER_START_DATETIME =
	'End Date & Time must be after Start Date & Time';
export const HAGGLE_PRODUCT_IDS_REQUIRED = 'At least one product is required';
export const HAGGLE_PRODUCT_IDS_MAX = 'You can select at most 100 products';
export const HAGGLE_ACCEPTABLE_MARGIN_MIN =
	'Max. Discount must be greater than 0';
export const HAGGLE_ACCEPTABLE_MARGIN_MAX =
	'Max. Discount must be less than 100';
export const HAGGLE_CHECKOUT_TIME_MIN =
	'Checkout time must be at least 5 minutes';
export const HAGGLE_CHECKOUT_TIME_MAX =
	'Checkout time cannot exceed 60 minutes';
export const HAGGLE_FREE_SHIPPING_THRESHOLD_MIN =
	'Free shipping threshold must be more than 10';
export const HAGGLE_FREE_SHIPPING_THRESHOLD_MAX =
	'Free shipping threshold must be less than 100000';
export const HAGGLE_SHOW_BANNER_REQUIRED =
	'Show Haggle Banner on Shopify setting is required';
export const HAGGLE_ADD_AUTO_SHOPIFY_POLICY_REQUIRED =
	'Shopify Policy setting is required';
export const HAGGLE_CUSTOM_RETURN_AND_EXCHANGE_POLICY_REQUIRED =
	'Custom Return and Exchange Policy is required';
export const HAGGLE_UPCOMING_PREVIEW_DATE_AFTER_CURRENT_TIME =
	'Preview date must be after current time';
export const HAGGLE_UPCOMING_PREVIEW_DATE_BEFORE_START_DATETIME =
	'Preview date must be before the event start time';
export const HAGGLE_FOLLOW_UP_OFFER_VALIDITY_AFTER_END_TIME =
	'Follow up offer validity must be after the event end time';
export const HAGGLE_HOST_HAGGLE_EVENT_ON_SHOPIFY_REQUIRED =
	'Host Haggle Event on Shopify setting is required';
export const HAGGLE_MIN_ORDER_VALUE_MIN =
	'Minimum order value must be greater than 1';
export const HAGGLE_MIN_ORDER_QUANTITY_MIN =
	'Minimum order quantity must be greater than 1';
export const HAGGLE_STRIPE_CONNECT_REQUIRED =
	'You need to connect your bank account to host haggles on Haggle Hub';
export const HAGGLE_B2B_PASSWORD_REQUIRED =
	'Password is required for semi-private or private haggle events';
export const HAGGLE_B2B_INVITED_EMAILS_REQUIRED =
	'At least one email is required to send invites';
